// Meta Pixel utility — handles initialization, PageView, and event tracking

const PIXEL_ID = '849974400733130'

declare global {
  interface Window {
    fbq?: any
    _fbq?: any
  }
}

let initialized = false

export function initMetaPixel() {
  if (typeof window === 'undefined' || initialized) return

  // Inject the Meta Pixel base code (safe variant — appends to <head> directly)
  if (!window.fbq) {
    const n: any = function () {
      n.callMethod ? n.callMethod.apply(n, arguments) : n.queue.push(arguments)
    }
    window.fbq = n
    if (!window._fbq) window._fbq = n
    n.push = n
    n.loaded = true
    n.version = '2.0'
    n.queue = []

    const script = document.createElement('script')
    script.async = true
    script.src = 'https://connect.facebook.net/en_US/fbevents.js'
    const target = document.head || document.body || document.documentElement
    if (target) {
      target.appendChild(script)
    }
  }

  // Inject the <noscript> fallback image
  if (document.body && !document.getElementById('fb-pixel-noscript')) {
    const noscript = document.createElement('noscript')
    noscript.id = 'fb-pixel-noscript'
    noscript.innerHTML = `<img height="1" width="1" style="display:none" src="https://www.facebook.com/tr?id=${PIXEL_ID}&ev=PageView&noscript=1" />`
    document.body.appendChild(noscript)
  }

  if (window.fbq) {
    window.fbq('init', PIXEL_ID)
    window.fbq('track', 'PageView')
  }
  initialized = true
}

export function trackEvent(eventName: string, params?: Record<string, any>) {
  if (typeof window === 'undefined' || !window.fbq) return
  if (params) {
    window.fbq('track', eventName, params)
  } else {
    window.fbq('track', eventName)
  }
}

export function trackAddToCart() {
  trackEvent('AddToCart', {
    content_name: 'El Mapa de la Noche Sin Reflujo',
    content_category: 'Digital Product',
    content_ids: ['mapa-noche-sin-reflujo'],
    content_type: 'product',
    value: 6.39,
    currency: 'USD',
  })
}
